// extracted by mini-css-extract-plugin
var _1 = "fSOYrXMYzpz_4Nnp7nUw";
export { _1 as "buildingModifierTable" }
